import { Option, columns } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { toArray, singleton, ofArray } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { Option as Option_1, ISize, column } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../Bfs.Web.Kundenportal/fable_modules/Fulma.3.0.0/Common.fs.js";
import * as react from "react";

export function box(body) {
    let children_4, children_2, children;
    return columns(ofArray([new Option(8, ["is-product-list"]), new Option(2, [])]), singleton(column(singleton(new Option_1(0, [new Screen(0, []), new ISize(16, [])])), singleton((children_4 = [(children_2 = [(children = [toArray(body)], react.createElement("div", {
        className: "content",
    }, ...children))], react.createElement("div", {
        className: "card-body",
    }, ...children_2))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto",
    }, ...children_4))))));
}

export const pageNotFound = box(ofArray([react.createElement("p", {}, "Die von Ihnen gesuchte Seite konnte leider nicht gefunden werden."), (() => {
    const children_4 = [react.createElement("a", {
        href: "/",
    }, "Zurück zum Start")];
    return react.createElement("p", {}, ...children_4);
})()]));

//# sourceMappingURL=Render.fs.js.map
